import React, { Suspense, useEffect, useState } from 'react';
import LoaderComponent from './LoaderComponent';
import { useAppContext, useAppContextUpdater } from '../services/app-context.service';
import { afterLogout, isPaid, UserClass } from '../services/user.services';
import { appSubDir, debugMode } from '../config';
import { isOnline } from '../functions/common.functions';
import { isPlatform } from '@ionic/react';
import { PushNotifications } from '@capacitor/push-notifications';
import { fcmSubscribeToTopic, fcmUnsubscribeFromTopic } from '../functions/fcm.functions';

// Lazy load the route components
const PrivateRoutes = React.lazy(() => import('../routes/PrivateRoutes'));
const PublicRoutes = React.lazy(() => import('../routes/PublicRoutes'));

const AuthGuard: React.FC = () => {
    const data = useAppContext();
    const setData = useAppContextUpdater()
    const inRootPath = window.location.pathname === appSubDir
    function goToProperLink() {
        if (!isOnline() || data.user?.token) {
            window.location.replace(appSubDir + "home/main")
        } else {
            window.location.replace(appSubDir + "login")
        }
    }
    function fcmAction(user?:UserClass) {
        if (isPlatform('capacitor')) {

            // On success, we should be able to receive notifications
            PushNotifications.addListener('registration', (token) => {
                if (user && isPaid(user.user)) {
                    fcmUnsubscribeFromTopic('free-user')
                    fcmSubscribeToTopic('paid-user')
                } else {
                    fcmUnsubscribeFromTopic('paid-user')
                    fcmSubscribeToTopic('free-user')
                }
            });
        }
    }
    useEffect(() => {
        if (inRootPath) {
            goToProperLink()
            return
        }

        if (!data.user) {
            fcmAction()
            return
        }

        const user = new UserClass(data.user)
        fcmAction(user)
        user.fetchFromOnline().then((res) => {
            setData({ ...data, user: res, isUserPaid: isPaid(res),isAppReadyToSync:true })
            fcmAction(new UserClass(res))
        }).catch((error) => {
            if (error.message === "Unauthenticated.") {
                afterLogout().then(() => {
                    window.location.href = appSubDir
                })
            } else {
                debugMode && console.error(error)
            }
        })
    }, [])

    if (inRootPath) {
        return null;
    }


    return (
        <Suspense fallback={<LoaderComponent msg="Loading Assets..." />}>
            {data.user ? <PrivateRoutes /> : <PublicRoutes />}
        </Suspense>
    );
};

export default AuthGuard;
